import {PhotoResource} from '@/common/api/api-raw-types';
import {Photo} from '@malt/asset-utils';

export function toPhoto(photoResource: PhotoResource): Photo {
    return new Photo(photoResource.baseUrl, photoResource.name);
}
